export { default as Calendar } from './Calendar';
export { default as DatePicker } from './DatePicker';
import zhCN from './locale/zh_CN';
import enUS from './locale/en_US';
var Locale = { zhCN: zhCN, enUS: enUS };
export { Locale };


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-calendar/es/index.js
// module id = 272
// module chunks = 0